// src/types.ts
var RESET_VALUE = Symbol("RESET_VALUE");
export {
  RESET_VALUE
};
//# sourceMappingURL=types.mjs.map
